var chunkToChildrenMap = {
	"1327": [
		54741
	],
	"1770": [
		54741
	],
	"7693": [
		54741
	],
	"17171": [
		54741
	],
	"22897": [
		54741
	],
	"36495": [
		54741
	],
	"39024": [
		54741
	],
	"41377": [
		54741
	],
	"43031": [
		54741
	],
	"51210": [
		54741
	],
	"55728": [
		54741
	],
	"58138": [
		54741
	],
	"60703": [
		54741
	],
	"61412": [
		54741
	],
	"65061": [
		54741
	],
	"67213": [
		54741
	],
	"73842": [
		54741
	],
	"78967": [
		54741
	],
	"88170": [
		54741
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));